export default "__VITE_ASSET__uE1EJ3QY__"